import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const SuccessContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const SuccessBox = styled.div`
  background: white;
  padding: 60px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
`;

const SuccessTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #000e2a;
  margin: 0;
`;

function IntegrationSuccess() {
  const location = useLocation();
  const isSuccess = new URLSearchParams(location.search).get("success") == "true";
  const provider = new URLSearchParams(location.search).get("provider").toUpperCase() || "Unknown Provider";
  console.log(location)
  useEffect(() => {
    setTimeout(() => window.close(), 5000);
  }, []);

  return (
    <SuccessBox>
      <SuccessTitle>
        {isSuccess
          ? `✅ ${provider} Authentication successful. The window will be closed automatically.`
          : `❌ ${provider} Authentication failed. Please try again.`}
      </SuccessTitle>
    </SuccessBox>
  );
}

export default IntegrationSuccess;
